import EventLayout from './EventLayout';

export default EventLayout;
